module.exports = __webpack_public_path__ + "img/PlayMerchantOfVenice.3dc658b5.jpg";